import { render, staticRenderFns } from "./admin.employee.edit.page.vue?vue&type=template&id=afa15e6a&scoped=true&"
import script from "./admin.employee.edit.page.vue?vue&type=script&lang=js&"
export * from "./admin.employee.edit.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.employee.edit.page.vue?vue&type=style&index=0&id=afa15e6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa15e6a",
  null
  
)

export default component.exports